import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CmaState } from '../cma.state';

@Component({
  selector: 'app-view-cma-valuation',
  templateUrl: './view-cma-valuation.component.html',
  styleUrls: ['./view-cma-valuation.component.scss'],
})
export class ViewCmaValuationComponent implements OnInit {
  onDestroyNotifier$ = new Subject();
  reportValuationDetails: any;
  homeValue: any;
  cmaReportId: any;
  cutoffs: any;
  cmaViewDetails: any;

  constructor(private cmaState: CmaState) {}

  ngOnInit(): void {
    this.cmaState.cmaReports.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res) {
        this.cmaViewDetails = res;
        this.reportValuationDetails = res.compReportData?.valueReport?.netProceeds;
        this.cutoffs =
          this.reportValuationDetails?.titleInsuranceFee +
          this.reportValuationDetails?.brokerCommission +
          this.reportValuationDetails?.homeWarrantyFee +
          this.reportValuationDetails?.recordingFee +
          this.reportValuationDetails?.transferTax;
        this.homeValue = res.compReportData?.valueReport?.homeValue;
      }
    });
  }
}
